export default __webpack_public_path__ + "static/media/window.b3ba9bbc.png";